import * as R from 'ramda'
import * as ReactRedux from 'react-redux'
import * as React from 'react'
import PropTypes from 'prop-types'

import * as common from '@rushplay/common'
import { useI18n } from '@rushplay/i18n'

import * as Configuration from './configuration'
import { DynamicImage } from './dynamic-image'
import { GameStatistics } from './game-statistics.js'
import { HtmlContent } from './html-content'
import { WelcomeOfferModeSelector } from './welcome-offer-mode-selector'

const PREVIEW_IMAGES = {
  jamminjars: [
    'jamminjars_preview_images/1.png',
    'jamminjars_preview_images/2.png',
    'jamminjars_preview_images/3.png',
    'jamminjars_preview_images/4.png',
  ],
}

export function WelcomeOfferGameInfo(props) {
  const i18n = useI18n()
  const [previewId, setPreviewId] = React.useState(1)
  const previewIds = [0, 1, 2, 3]

  const cdnPrefix = ReactRedux.useSelector(state =>
    Configuration.getCdnPrefix(state.configuration)
  )

  return (
    <common.Box display="flex" flexWrap="wrap" justifyContent="center">
      <common.Box display="flex" flexDirection="column" m={1} width="450px">
        <DynamicImage
          mb={1}
          borderRadius={0}
          resizingWidth={450}
          source={`/${cdnPrefix}/${PREVIEW_IMAGES[props.gameKey][previewId]}`}
          alt={props.gameKey}
          width="100%"
        />
        <common.Box
          display="grid"
          gridTemplateColumns="repeat(4, 1fr)"
          gridGap={1}
        >
          {R.map(
            id => (
              <common.Box
                key={id}
                opacity={id === previewId ? 1 : 0.3}
                borderStyle="solid"
                borderWidth="2px"
                borderColor={id === previewId ? '#fff' : 'transparent'}
                onClick={() => setPreviewId(id)}
              >
                <DynamicImage
                  borderRadius={0}
                  resizingWidth={100}
                  source={`/${cdnPrefix}/${PREVIEW_IMAGES[props.gameKey][id]}`}
                  alt={`preview-${id}`}
                  width="100%"
                />
              </common.Box>
            ),
            previewIds
          )}
        </common.Box>
      </common.Box>
      <common.Box
        display="flex"
        justifyContent="space-between"
        flexDirection="column"
        m={1}
        maxWidth="450px"
        width="100%"
      >
        <common.Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems={['center', null, 'flex-start']}
          pb={2}
          width="100%"
        >
          <common.Box
            bg="featured-label-background"
            borderRadius={0}
            padding={0}
            width="max-content"
          >
            <common.Text fontSize={1} fontFamily="head" fontWeight="bold">
              {i18n.translate('featured-game')}
            </common.Text>
          </common.Box>
          <common.Box
            pt={1}
            pb={0}
            fontSize={4}
            fontWeight="bold"
            color="g-text"
            textAlign="center"
          >
            {props.title}
          </common.Box>
          <common.Text fontSize={1} color="g-text" textAlign="center">
            {props.provider}
          </common.Text>
        </common.Box>
        <GameStatistics
          catalogType="casino"
          gameId={props.gameId}
          jackpotValue={props.jackpotValue}
          feature={props.feature}
          rtp={props.rtp}
          volatility={props.volatility}
          biggestWinCents={props.biggestWinCents}
          minBetCents={props.minBetCents}
          maxBetCents={props.maxBetCents}
          dealerName={props.dealerName}
          seatsTotal={props.seatsTotal}
          seatsAvailable={props.seatsAvailable}
          betBehind={props.betBehind}
          releaseDate={props.releaseDate}
        />
        {i18n.hasTranslation(props.description) && (
          <common.Box
            as="p"
            color="g-text"
            fontWeight="bold"
            fontSize={2}
            textAlign="center"
            pb={2}
          >
            <HtmlContent html={{ __html: i18n.translate(props.description) }} />
          </common.Box>
        )}
        <common.Box display="flex" py={2} justifyContent="center">
          <WelcomeOfferModeSelector
            gameId={props.gameId}
            gameKey={props.gameKey}
          />
        </common.Box>
      </common.Box>
    </common.Box>
  )
}

WelcomeOfferGameInfo.propTypes = {
  gameKey: PropTypes.string,
  backgroundUrl: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string,
  provider: PropTypes.string,
  titleUrl: PropTypes.string,
  gameId: PropTypes.string,
  jackpotValue: PropTypes.number,
  feature: PropTypes.string,
  rtp: PropTypes.string,
  volatility: PropTypes.string,
  biggestWinCents: PropTypes.number,
  minBetCents: PropTypes.number,
  maxBetCents: PropTypes.number,
  dealerName: PropTypes.string,
  seatsTotal: PropTypes.number,
  seatsAvailable: PropTypes.number,
  betBehind: PropTypes.bool,
  releaseDate: PropTypes.string,
}

// for @loadable/components
export default WelcomeOfferGameInfo
